/* Tysk katalog for locale-superplumma-workspace.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'route.superplumma': 'SuperPlumma',
  'nav.superplumma': 'SuperPlumma',
  'navhelp.superplumma': 'Arbeite mit SuperPlumma im Chat zusammen und verfolge die Aufgabe im Arbeitsbereich.',
  'spw.eyebrow': 'Deine Buchhaltungsassistentin',
  'spw.intro': 'Was machen wir heute? Bitte mich, eine Rechnung zu erstellen, oder lade einen Beleg hoch. Das Dokument wird hier angezeigt, während wir daran arbeiten.',
  'spw.upload': 'Beleg hochladen',
  'spw.camera': 'Foto aufnehmen',
  'spw.dropHint': 'Du kannst einen Beleg auch hier ablegen.',
  'spw.drop': 'Beleg hier ablegen',
  'spw.uploading': 'Beleg wird hochgeladen …',
  'spw.uploadError': 'Der Beleg konnte nicht hochgeladen werden.',
  'spw.saveDraft': 'Entwurf speichern',
  'spw.issued': 'Die Rechnung wurde erstellt.',
  'spw.showProposal': 'Vorschlag anzeigen',
  'spw.editDetails': 'Details ändern',
  'spw.addReceipt': 'Lade einen Beleg im Chat hoch oder nimm ein Foto auf.',
  'spw.proposal': 'Buchungsvorschlag',
  'spw.supplierMissing': 'Kein Lieferant gewählt',
  'spw.account': 'Konto',
  'spw.vat': 'MwSt.',
  'spw.notSelected': 'Nicht gewählt',
  'spw.readingHint': 'Der Vorschlag erscheint, sobald der Beleg gelesen oder die Details ausgefüllt sind.',
  'spw.paymentAccount': 'Zahlungskonto',
  'spw.unpaid': 'Nicht bezahlt',
  'spw.approvalHint': 'Bitte SuperPlumma zu buchen, wenn der Vorschlag fertig ist. Du kannst die Aktion prüfen und genehmigen.',
  'spw.openTask': 'Aufgabe öffnen',
  'spw.chat': 'Chat',
  'spw.workspace': 'Arbeitsbereich',
  'spw.shared': 'Eine Buchhaltung. Voller Überblick.',
  'spw.receipts': 'Belegerfassung',
  'spw.purchase': 'Einkauf',
  'spw.sale': 'Verkauf',
  'spw.invoice': 'Rechnungsentwurf',
  'spw.choose': 'Aufgabe wählen',
  'spw.loading': 'Arbeitsbereich wird geöffnet …',
  'spw.loadError': 'Der Arbeitsbereich konnte nicht geladen werden. Dein Gespräch bleibt erhalten.',
  'spw.retry': 'Erneut versuchen',
  'spw.unavailable': 'Öffne SuperPlumma in einem aktiven Unternehmen, um zu starten.',
  'spw.changeTitle': 'Aufgabe wechseln?',
  'spw.changeText': 'Speichere eventuelle Änderungen im Formular, bevor du die Aufgabe wechselst. Nicht gespeicherte Änderungen können verloren gehen.',
  'spw.changeConfirm': 'Aufgabe wechseln',
});
